import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import renderTextInputWithFeedback from '../../../../components/ui/forms/renderTextInputWithFeedback'
import formValidators from '../../../../utils/validation/formValidators'
import { currentUserSuccess, currentUserPropTypes } from '../../../../store/shared/currentUserDuck'
import notificationsUtils from '../../../../utils/notifications/notificationsUtils'
import { performUpdateUserProfile, userProfilePropTypes } from '../userProfileDuck'
import fullstory from '../../../../utils/constants/fullstory'

class UserProfileNameForm extends Component {
  render() {
    const { handleSubmit, pristine, invalid, userProfile, toggleNameForm } = this.props

    return (
      <div>
        {userProfile.error && <h5 className="text-center text-danger">{userProfile.error}</h5>}
        <form>
          <Field
            className={fullstory.classNames.textInput}
            component={renderTextInputWithFeedback}
            name="firstName"
            placeholder="First Name"
          />
          <Field
            className={fullstory.classNames.textInput}
            component={renderTextInputWithFeedback}
            name="lastName"
            placeholder="Last Name"
          />
          <Field
            className={fullstory.classNames.textInput}
            component={renderTextInputWithFeedback}
            name="altEmail"
            placeholder="Alternate Email"
          />
          <button
            onClick={handleSubmit}
            className="btn btn-primary"
            style={{ width: '100%' }}
            disabled={pristine || invalid}
          >
            Save
          </button>
          <div className="text-right">
            <button
              onClick={() => toggleNameForm(false)}
              type="button"
              tabIndex={-1}
              className="btn btn-clear"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    )
  }
}

UserProfileNameForm.propTypes = {
  currentUserSuccess: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  currentUser: currentUserPropTypes,
  performUpdateUserProfile: PropTypes.func.isRequired,
  userProfile: userProfilePropTypes,
  toggleNameForm: PropTypes.func.isRequired,
}

const validate = values => {
  const errors = {}
  errors.altEmail = formValidators.isRequired(values.altEmail)
  errors.altEmail = formValidators.isAnEmail(values.altEmail)
  errors.firstName = formValidators.isRequired(values.firstName)
  errors.lastName = formValidators.isRequired(values.lastName)
  return errors
}

const wrappedWithForm = reduxForm({
  form: 'userProfileNameForm',
  onSubmit: async (values, _dispath, props) => {
    try {
      const { user } = await props.performUpdateUserProfile(values)
      props.currentUserSuccess(user)
      props.toggleNameForm(false)
      notificationsUtils.showSuccessNotification('Updated user!')
    } catch (error) {
      notificationsUtils.showErrorNotification('Failed to update user')
    }
  },
  validate,
})(UserProfileNameForm)

const mapStateToProps = _state => ({
  currentUser: _state.currentUser,
  userProfile: _state.userProfile,
  initialValues: {
    ..._state.currentUser.user.profile,
    ..._state.currentUser.user.info,
  },
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      currentUserSuccess,
      performUpdateUserProfile,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(wrappedWithForm)



// WEBPACK FOOTER //
// ./src/routes/authenticated/UserProfile/components/UserProfileNameForm.js